import React from "react";
import "./GrayboxLabel.scss";

export default ({ children }) => {
  return <div className="graybox-label">{children}</div>;
};
